var Related = function(){
    var _this = this;

    function _initIscrollLeft(){
        _this.relatedScrollLeft = new IScroll(document.querySelector('.vr-related__content'), {
            mouseWheel: true,
            scrollbars: true,
            interactiveScrollbars: true,
            fadeScrollbars: false,
            zIndex: 'auto',
            bounce: false,
            mouseWheelSpeed: 60
        });
    }

    function _handleScrollRefresh(){
        /* Refresh iScroll height when, b-lazy images for desktop related left brochrues, load. */
        window.addEventListener('view.related.left.img.loaded', function(e) {
            if(!isMobile && typeof _this.relatedScrollLeft !== 'undefined' && _this.relatedScrollLeft){
                _this.relatedScrollLeft.refresh();
            }
        });        
    }
    

    function _init(){
        _initIscrollLeft();
        _handleScrollRefresh();
    }

    _this.init = _init;
};